import { render, staticRenderFns } from "./BAteTreeForm.vue?vue&type=template&id=2108c7c4&"
import script from "./BAteTreeForm.vue?vue&type=script&lang=js&"
export * from "./BAteTreeForm.vue?vue&type=script&lang=js&"
import style0 from "./BAteTreeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VInput } from 'vuetify/lib/components/VInput';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCheckbox,VDivider,VInput,VSkeletonLoader})
